const newList = [{
        path: "/projectDetail",
        name: "ProjectDetail",
        component: () =>
            import ("@/views/newHouse/detail.vue"),
        meta: {
            title: "项目详情"
        }
    },
    {
        path: "/lotteryDetail",
        name: "lotteryDetail",
        component: () =>
            import ("@/views/newHouse/lotteryDetail.vue"),
        meta: {
            title: "项目详情"
        }
    },
    {
        path: "/projectXq",
        name: "ProjectXq",
        component: () =>
            import ("@/views/newHouse/projectXq.vue"),
        meta: {
            title: "楼盘详情"
        }
    },
    {
        path: "/nkt",
        name: "Nkt",
        component: () =>
            import ("@/views/newHouse/nkt.vue"),
        meta: {
            title: "鸟瞰图"
        }
    },
    {
        path: "/photo",
        name: "Photo",
        component: () =>
            import ("@/views/newHouse/photo.vue"),
        meta: {
            title: "相册"
        }
    },
    {
        path: "/saleProgress",
        name: "SaleProgress",
        component: () =>
            import ("@/views/newHouse/saleProgress.vue"),
        meta: {
            title: "销售进度"
        }
    },
    {
        path: "/announcePre",
        name: "AnnouncePre",
        component: () =>
            import ("@/views/newHouse/announcePre.vue"),
        meta: {
            title: "预售列表"
        }
    },
    {
        path: "/announceNow",
        name: "AnnounceNow",
        component: () =>
            import ("@/views/newHouse/announceNow.vue"),
        meta: {
            title: "现售公示"
        }
    },
    {
        path: "/announceDetail",
        name: "AnnounceDetail",
        component: () =>
            import ("@/views/newHouse/announceDetail.vue"),
        meta: {
            title: "预售详情"
        }
    },
    {
        path: "/oneHouseOnePrice",
        name: "OneHouseOnePrice",
        component: () =>
            import ("@/views/newHouse/oneHouseOnePrice.vue"),
        meta: {
            title: "未售房源一房一价"
        }
    },
    {
        path: "/oneHouseOnePriceDetail",
        name: "OneHouseOnePriceDetail",
        component: () =>
            import ("@/views/newHouse/oneHouseOnePriceDetail.vue"),
        meta: {
            title: "未售房源一房一价"
        }
    },
    {
        path: "/saleInfo",
        name: "SaleInfo",
        component: () =>
            import ("@/views/newHouse/saleInfo.vue"),
        meta: {
            title: "销售状态"
        }
    },
    {
        path: "/newsList",
        name: "NewsList",
        component: () =>
            import ("@/views/newHouse/newsList.vue"),
        meta: {
            title: "楼盘动态"
        }
    },
    {
        path: "/newsDetail",
        name: "NewsDetail",
        component: () =>
            import ("@/views/newHouse/newsDetail.vue"),
        meta: {
            title: "新闻详情"
        }
    },
    {
        path: "/argumentList",
        name: "ArgumentList",
        component: () =>
            import ("@/views/newHouse/argumentList.vue"),
        meta: {
            title: "点评"
        }
    },
    {
        path: "/argumentSubmit",
        name: "ArgumentSubmit",
        component: () =>
            import ("@/views/newHouse/argumentSubmit.vue"),
        meta: {
            title: "点评",
            isLogin: true
        }
    },
    {
        path: "/newMap",
        name: "newMap",
        component: () =>
            import ("@/views/newHouse/map.vue"),
        meta: {
            title: "地图找房"
        }
    }
];
export default newList;